/**
 * Sélecteur de période mensuelle.
 * Utilise <input type="month"> natif — bien supporté mobile (iOS/Android
 * ouvrent un picker natif), et rendu en texte saisissable sur desktop.
 *
 * value / onChange suivent le format "YYYY-MM".
 */
export default function PeriodPicker({ value, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <label
        htmlFor="period-picker"
        className="text-sm font-medium text-slate-600 shrink-0"
      >
        Période
      </label>
      <input
        id="period-picker"
        type="month"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm text-slate-900 focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
      />
    </div>
  );
}
